/*
 * Proprietary and Confidential
 *
 * Copyright (c) [2018] -  [] Marcelo H. Krebber - Munich, London 2018
 * All Rights Reserved.
 *
 * Dissemination or reproduction of this file [sidebar-entry-space.js] or parts within
 * via any medium is strictly forbidden unless prior written permission is obtained
 * from <marcelo.krebber@gmail.com>
 *
 * Last modified: 13.02.20, 11:32
 */

import React, {Fragment, useState} from 'react';
import {Link} from 'react-router-dom';
import {getImageServerMediumUrl} from "../../../actions/environment";
import {BoxedLink} from "../../navigation/buttons/nav-buttons";
import {AnimatedChevronIcon2} from "../../navigation/links/nav-headlines";
import SmoothScrollbar from "../../scrollbars/smooth-scrollbar";
import SpaceAccessIcon from "../../navigation/icons/space-access-icon";
import {MembershipIconShort} from "../../navigation/icons/membership-icon";
import {fs_bigger, fs_smaller, GroupIcon, StarsIcon} from "../../navigation/icons/nav-icons";
import {useLocationCategory} from "../../../selectors";

const SidebarEntryPeekSpace = ({peekspace, className, text = null, size = 'small'}) => {
    const [showSubMenu, setShowSubMenu] = useState(false);
    const {categoryName} = useLocationCategory();

    // any children but 'GALLERY' are rendered as submenu entries
    // const renderChildren = (user, space) => {
    const renderChildren = (peekspace) => {
        const children = peekspace.children
        .filter(child => child.type !== 'GALLERY')
        .map(child => {
            const target = `/${peekspace.username}/space/${child.id}`;
            return <li key={child.id} className="nav-item">
                <Link to={target} className="ml-2">{child.name}</Link>
                <SpaceAccessIcon size={fs_bigger} access={child.access}/>
                <MembershipIconShort membership={child.membership}/>
            </li>
        });
        return <div className="sidebar-submenu">
            <ul className="nav flex-column">{children}</ul>
        </div>;
    }

    const toggleShowSubMenu = (event) => {
        event.preventDefault()
        setShowSubMenu(!showSubMenu);
    }

    const childrenCount = peekspace => {
        let children = null;
        if (peekspace.children) {
            children = peekspace.children.filter(child => child.type !== 'GALLERY')
        }
        return children && children.length > 0;
    }

    const activespace = `/${peekspace.username}/space/${peekspace.id}`;
    const hasChildren = childrenCount(peekspace);
    const containerSize = size === 'bigger' ? 'sidebar-body-container-big' : 'sidebar-body-container-small';
    const imageSize = size === 'bigger' ? 'sidebar-image-big' : 'sidebar-image-small';

    return <div className='mb-1'>
        <BoxedLink to={activespace} className='sidebar-card-container text-dark shadow'>
            <div className={`sidebar-body-container ${containerSize}`}>
                <div className='sidebar-image-container'>
                    <img className={`sidebar-image ${imageSize}`} src={getImageServerMediumUrl(peekspace.url)}/>
                </div>
                <div className='w-100 pt-4 p-1 overflow-y-hidden'>
                    <div className='d-flex  align-items-center justify-content-between sidebar-space-title'>
                        <span className='mr-1'>{peekspace.name}</span>
                        <div className="d-flex align-items-center">
                            <SpaceAccessIcon access={peekspace.access}/>
                            <MembershipIconShort membership={peekspace.membership}/>
                        </div>
                    </div>
                    <div className='small mb-2'>{peekspace.city}</div>

                    {size === 'bigger' && <div>
                        <div className='small clr-red'>Testimonials</div>
                        <div className='d-flex justify-content-between align-items-center'>
                            <div className="align-items-center d-flex">
                                <span className='mr-1'>200+</span>
                                <GroupIcon size={fs_smaller}/>
                            </div>
                            <div><StarsIcon size={fs_smaller}/>
                                <StarsIcon size={fs_smaller}/>
                                <StarsIcon size={fs_smaller}/>
                            </div>
                        </div>
                        <div className='mt-3'><span className='fw-bolder'>Trending</span></div>
                    </div>}
                </div>
                <span className="image-box-category small">{categoryName(peekspace.category)}</span>

            </div>
            {hasChildren && <AnimatedChevronIcon2 onClick={toggleShowSubMenu} isOpen={showSubMenu}/>}
        </BoxedLink>

        {showSubMenu && hasChildren &&
            <SmoothScrollbar className="sidebar-submenu mt-2">
                {renderChildren(peekspace)}
            </SmoothScrollbar>}
    </div>
}

export default SidebarEntryPeekSpace;
